import './App.css';
import { Routes, Route, Navigate } from 'react-router-dom';
import Layout from './layouts/authenticated';
import Login from './pages/auth';
import Home from './pages/home';
import PageNotFound from './pages/pagenotfound';
import { AuthProvider, useAuth } from './providers/auth.provider';
import PublicLayout from './layouts/public';
import Profile from './pages/profile';
import FAQSection from './pages/faq';
import HelpAndSupport from './pages/contacts';
import LoanDetails from './pages/loan-details';
import ApplyLoan from './pages/apply-loan';
import CookiesConsent from './utils/cookies_consent';
import VerifyEmail from './pages/verifyEmail';         
const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const { isAuthenticated, loading } = useAuth();
  if (loading) {
    return <div>Loading...</div>; // Or a proper loading spinner
  }
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  return <Layout>{children}</Layout>;
};

const App = () => {
  const { isAuthenticated } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={isAuthenticated ? <Navigate to="/" /> : <PublicLayout><Login /></PublicLayout>} />

      <Route path="/" element={<ProtectedRoute ><Home /></ProtectedRoute>} />
      <Route path="/profile" element={<ProtectedRoute ><Profile /></ProtectedRoute>} />
      <Route path="/faqs" element={<ProtectedRoute ><FAQSection /></ProtectedRoute>} />
      <Route path="/help-and-support" element={<ProtectedRoute ><HelpAndSupport /></ProtectedRoute>} />
      <Route path="/loan" element={<ProtectedRoute ><LoanDetails /></ProtectedRoute>} />
      <Route path="/loan/apply" element={<ProtectedRoute ><ApplyLoan /></ProtectedRoute>} />
      {/* <Route path="/history" element={<ProtectedRoute ><History /></ProtectedRoute>} /> */}
      <Route path="/verify-email" element={<ProtectedRoute><VerifyEmail /></ProtectedRoute>} /> 


      <Route path="*" element={<ProtectedRoute><PageNotFound /></ProtectedRoute>} />
    </Routes>
  );
};

const AppWrapper = () => {
  return (
    <>
      <AuthProvider>
        <CookiesConsent />
        <App />
      </AuthProvider>
    </>
  );
};

export default AppWrapper;